import { createSlice } from '@reduxjs/toolkit';
import { RemoveCryoboxFromStagingState } from './types';
import { StoreStatus } from '../../core/types/common.types';
import { removeCryoboxFromStagingThunk } from './thunks';

// Initial State
const initialState: RemoveCryoboxFromStagingState = {
  errors: null,
  status: StoreStatus.IDLE,
  values: null,
  response: null,
};

// Slice
export const removeCryoboxFromstagingSlice = createSlice({
  name: 'shipment',
  initialState,
  reducers: {
    removeCryoboxFromstagingReset: () => ({
      ...initialState,
    }),
  },
  extraReducers: (builder) => {
    builder.addCase(removeCryoboxFromStagingThunk.pending.type, (state) => {
      state.status = StoreStatus.BUSY;
    });
    builder.addCase(removeCryoboxFromStagingThunk.fulfilled.type, (state, action: any) => {
      state.status = StoreStatus.IDLE;
      state.response = action.payload;
      state.errors = null;
      state.values = null;
    });
    builder.addCase(removeCryoboxFromStagingThunk.rejected.type, (state, action: any) => {
      state.status = StoreStatus.ERROR;
      state.errors = action.payload;
      state.response = null;
    });
  },
});

// Action creators
export const { removeCryoboxFromstagingReset } = removeCryoboxFromstagingSlice.actions;
export * from './thunks';
export default removeCryoboxFromstagingSlice.reducer;
